// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3t9eT","approved":"Status_approved__24E-q","rejected":"Status_rejected__Rpb5L","expired":"Status_expired__3eXKR","label":"Status_label__1Qbcv"};